// extracted by mini-css-extract-plugin
export var container = "ExpiredUserEmptyState_container__b9L3K";
export var header = "ExpiredUserEmptyState_header__A1LW0";